<template>
  <b-container v-if="servicioSeleccionado">
    <Service-form
      :servicioOriginal="servicioSeleccionado"
      :puedoEditar="puedoEditar()"
      @servicioSubmit="callUpdateService"
    ></Service-form>
  </b-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ServiceForm from "@/components/services/ServiceFormV2";
export default {
  components: {
    ServiceForm
  },
  computed: {
    ...mapState("services", ["servicioSeleccionado"])
  },
  methods: {
    ...mapActions({
      updateService: "services/updateService"
    }),
    puedoEditar() {
      if (this.servicioSeleccionado.Estado === "Documentado") return true;
      return false;
    },
    async callUpdateService(data) {
      //console.log("DATA: " + JSON.stringify(data));
      let ok = await this.updateService(data.servicio);
      //console.log("OK: " + JSON.stringify(ok));
      //console.log(data.imprimir ? "imprimo" : "no imprimo");
      if (ok.estado) {
        if (data.imprimir) {
          //let numeroExpedicion = ok.respuesta.GrabarExpedicionSolicitudOS.EXPEDICION.REFERENCIAENTREGA;
          let numeroExpedicion = data.servicio.ReferenciaVia;
          let numeroOrden = data.servicio.Codigo;
          await this.imprmir(numeroExpedicion, numeroOrden);
        }
        this.$router.push("/servicios");
      }
    },
    async imprmir(numeroExpedicion, numeroOrden) {
      this.$store.commit("setLoading", true, { root: true });
      let ruta = this.$apiRoute + "expediciones/etiqueta?numeroExpedicion=" + numeroExpedicion + "&numeroOrden=" + numeroOrden;

      let res = await fetch(
        ruta,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + window.localStorage.getItem("_token")
          }
        }
      );

      if (!res.ok) {
        this.$store.commit("setLoading", false, { root: true });
        this.$toast("No se pudo imprimir", { color: "blue" });
        return;
      }

      let b64 = await res.json();
      b64 = "data:application/pdf;base64," + b64.ImprimirEtiqueta;
      res = await fetch(b64);
      let response = await res.blob();
      let blob = new Blob([response], { type: "application/pdf" });
      var fileUrl = URL.createObjectURL(blob);
      var wnd = window.open(fileUrl, "_blank");
      this.$store.commit("setLoading", false, { root: true });

      await this.sleep(500);
      try { wnd.print(); } catch (error) { }

      /*let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Etiqueta-" + numeroExpedicion + ".pdf";*/
      //link.click();
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
  }
};
</script>
